export const getFontStyling = (bold: boolean = false) => ({
	headline: `
        font-size: 48px;
        line-height: 56px;
        font-weight: ${bold ? 700 : 400};
    `,
	l: `
        font-size: 18px;
        line-height: 26px;
        font-weight: ${bold ? 600 : 400};
    `,
	m: `
        font-size: 16px;
        line-height: 24px;
        font-weight: ${bold ? 600 : 400};
    `,
	sm: `
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
    `,
	xs: `
        font-size: 12px;
        line-height: 16px;
        font-weight: 300;
        `
});
